// const showSnackBar = (message) => {
//     const snackbarContainer = document.querySelector('#taxonomy-generated');
//     const data = {
//         message: message,
//         timeout: 5000,
//     };
//     snackbarContainer.MaterialSnackbar.showSnackbar(data);
// };
const showSnackBar = {
    showMessage: function(message) {
        const snackbarContainer = document.querySelector('#taxonomy-generated');
        const data = {
            message: message,
            timeout: 5000,
        };
        snackbarContainer.MaterialSnackbar.showSnackbar(data);
    },
    showSignIn: function(message){
        const snackbarContainer = document.querySelector('#login-bar');
        const data = {
            message: message,
            timeout: 600,
        };
        snackbarContainer.MaterialSnackbar.showSnackbar(data);
    }
};

export default showSnackBar;